import axios from 'axios';
var axiosInstance = axios.create({
   baseURL: `https://nestle.autometrics.in/nestle/` 
   // baseURL: `http://localhost:5000/nestle/` 
});
export default axiosInstance;
